import Skeleton from './Skeleton';

import './styles/style.scss';

export default Skeleton;



// WEBPACK FOOTER //
// ./src/components/Skeleton/index.js